import { render, staticRenderFns } from "./MerchantChannelTypeDayClear.vue?vue&type=template&id=63ab9d22&"
import script from "./MerchantChannelTypeDayClear.vue?vue&type=script&lang=ts&"
export * from "./MerchantChannelTypeDayClear.vue?vue&type=script&lang=ts&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

component.options.__file = "MerchantChannelTypeDayClear.vue"
export default component.exports